// extracted by mini-css-extract-plugin
export default {"floatingBtn":"FloatingBtn_floatingBtn__vCTGR"};